<div class="datatable-filter">
  <div
    class="dropdown"
    ngbDropdown
    [attr.data-automation]="dataAutomation()"
    [placement]="'bottom-start'"
    (openChange)="openChange($event)"
  >
    <button
      [id]="dataAutomation()"
      type="button"
      class="btn btn-border dropdown-toggle"
      [class]="!!value || neverUsed ? 'btn-primary' : 'btn-default'"
      [disabled]="isViewLoading"
      data-automation="datatable-slider-filter-dropdown-toggle-button"
      ngbDropdownToggle
    >
      <span class="font-regular">{{ label() | translate }}{{ ': ' }}</span>
      <span class="font-black" data-automation="datatable-slider-filter-value">
        {{ getFilterLabel() | translate: { days: value } }}
      </span>
    </button>
    @if (!!value) {
      <button
        type="button"
        class="btn btn-border btn-primary clear-margin"
        data-automation="datatable-clear-slider-filter-button"
        (click)="clearInput()"
      >
        <i [ngClass]="ziroIcons.CLEAR"></i>
      </button>
    }
    <div ngbDropdownMenu class="dropdown-menu">
      <div class="datatable-container">
        <div
          class="form-check form-switch form-switch-right"
          [attr.data-automation]="'datatable-slider-never-used-select'"
        >
          <label
            class="form-check-label"
            [for]="'datatable-slider-never-used-select'"
            [innerHTML]="toggleLabel() | escapeHtml"
          ></label>
          <input
            type="checkbox"
            class="form-check-input"
            [id]="'datatable-slider-never-used-select'"
            [(ngModel)]="neverUsed"
            (ngModelChange)="updateSlider()"
            [disabled]="isViewLoading"
          />
        </div>
        <div class="mt-2 custom-slider" [hidden]="neverUsed">
          <span class="slider-label" [innerHTML]="sliderLabel() | escapeHtml"></span>
          <div class="d-flex justify-content-center mt-2">
            <div class="minmax-slider-value">
              {{ floorValueLabel() ? (floorValueLabel() | translate) : floorValue() }}
            </div>
            <ziro-datatable-slider
              [(value)]="sliderValue"
              [min]="floorValue()"
              [max]="ceilValue()"
              [disableDropDownOptions]="disableDropDownOptions"
              (valueChange)="onChange($event)"
            ></ziro-datatable-slider>
            <div class="minmax-slider-value">{{ ceilValue() }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
